// extracted by mini-css-extract-plugin
export default {"item":"FriendListItem_item__6Bq+-","status":"FriendListItem_status__VAiFZ","avatar":"FriendListItem_avatar__3ue9x","name":"FriendListItem_name__AsW6F"};